import { Field, Dropdown } from '@carboledger/ui';
import { useTranslations } from '@/hooks';
import { EMPTY_LIST } from '@/lib/utils';

/**
 * Props:
 *   options  the slice's own Yes/No pair — the two endpoints accept different shapes
 *   value    pins the value, for a facility the server forces to "No"
 */
export const MultiSiteTransferField = ({ options = EMPTY_LIST, value }) => {
  const t = useTranslations();

  return (
    <Field name="multiSiteTransfer" required>
      {({ id, name, value: fieldValue, onChange, onBlur, status, message, required }) => (
        <Dropdown
          disabled
          id={id}
          name={name}
          label={t('FORM_MULTI_SITE_TRANSFER')}
          value={value ?? fieldValue}
          onChange={onChange}
          onBlur={onBlur}
          status={status}
          message={message}
          required={required}
          options={options}
        />
      )}
    </Field>
  );
};
